// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "RoutingMetadataHealthReport" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { MissingMetadataEntryGenShape } from "./missing-metadata-entry.gen";
import { PastReviewEntryGenShape } from "./past-review-entry.gen";
import { OrphanedMetadataEntryGenShape } from "./orphaned-metadata-entry.gen";

export const RoutingMetadataHealthReportGenShape = z.strictObject({
  libraryId: z.string(),
  adviceSetCount: z.number(),
  missing: z.array(MissingMetadataEntryGenShape),
  pastReview: z.array(PastReviewEntryGenShape),
  orphaned: z.array(OrphanedMetadataEntryGenShape),
});
